import axios, { AxiosRequestConfig } from 'axios'
import { getCookie, removeCookie } from './utils'
import { toast } from 'sonner';

// create an axios instance
const service = axios.create({
  baseURL: process.env.NEXT_PUBLIC_BASE_URL, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 60000, // request timeout
  transformResponse: [(data) => {
    // 使用正则表达式找到长数字，并将其转为字符串格式
    // 15是一个示例阈值，可以根据实际需求调整
    // const updatedData = data.replace(/:\s?(\d{15,})/g, ': "$1"')
    try {
      if (typeof data === 'string') {
        const updatedData = data.replace(/(?<=[\[:,\s])(\d{19,})(?=[,\]\s])/g, (match, p1, offset, originalString) => {
          // 检查匹配的数字前的引号的前四个字符
          const quoteIndex = offset - 4;
          if (originalString[quoteIndex] === '\\') {
            // 如果引号前已经有反斜杠，则保持原样
            return `\\"${match}\\"`;
          } else {
            // 如果引号前没有反斜杠，添加反斜杠来转义引号
            return `"${p1}"`;
          }
        });
        return JSON.parse(updatedData);
      }
      return data;
    } catch (err) {
      console.log(err)
    }
    // 原生的 JSON.parse 会把过长的 Number 类型的精度丢失
    // 所以先处理完所有超过 15 位的整数类型转为字符串, 再用原生的JSON.parse()
  }]

})

// request interceptor
service.interceptors.request.use(
  config => {
    const token = getCookie('token') || 'test'
    // do something before request is sent
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    config.headers['Authorization'] = 'Bearer ' + token
    // config.headers['Authorization'] = store.getters.token
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  (response) => {
    const res = response.data
    if (res.code !== 200 && res.code !== 20000) {
      // 认证失败
      if (res.code === 401) {
        // 清除 token
        removeCookie('token');
        window.location.href = '/';
        return Promise.reject('登录账户过期，请重新登录')
      }

      if (res.message) {
        toast.error(res.message)
        return Promise.reject(new Error(res.message || 'Error'))
      } else {
        toast.error('网络异常...请检查网络连接...')
        return res.message || 'Error'
      }
      // return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    toast.error('网络异常...请检查网络连接...')
    return Promise.reject(error)
  }
)


function request<T>(options: AxiosRequestConfig): Promise<CustomResponse.DefaultResponse<T>> {
  return service(options) as Promise<CustomResponse.DefaultResponse<T>>;
}

export default request;